import { useContext } from 'react'
import { Button } from 'antd'
import { ThemeContext } from '@/src/contexts'

import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
config.autoAddCss = false
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '@/src/lib'

export const ThemeButton = () => {
  const { isDarkMode, handleClick } = useContext(ThemeContext)

  return (
    <div className='hidden'>
      <Button
        style={{ background: 'none', border: 'none' }}
        onClick={handleClick}
        aria-label='Theme'
        className='hidden'
      >
        <FontAwesomeIcon
          className='text-white'
          icon={isDarkMode ? 'moon' : 'sun'}
        />
      </Button>
    </div>
  )
}
